import { provideWidgetClass } from 'scrivito'

export const DXPDetailsWidget = provideWidgetClass('DXPDetailsWidget', {})
